"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.bpfrpt_proptype_controlsGroupProps = exports["default"] = void 0;

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireWildcard(require("react"));

var _styled = require("./styled");

var _propTypes = _interopRequireDefault(require("prop-types"));

var bpfrpt_proptype_controlsGroupProps = {
  neighboringInGroup: _propTypes["default"].oneOf(["right", "both", "left"])
};
exports.bpfrpt_proptype_controlsGroupProps = bpfrpt_proptype_controlsGroupProps;

var getNeighboringInGroup = function getNeighboringInGroup(index, length) {
  if (index === 0) {
    return 'right';
  }

  if (index === length - 1) {
    return 'left';
  }

  return 'both';
};

/* eslint-disable react/prop-types */
var Swap =
/*#__PURE__*/
function (_PureComponent) {
  (0, _inherits2["default"])(Swap, _PureComponent);

  function Swap() {
    (0, _classCallCheck2["default"])(this, Swap);
    return (0, _possibleConstructorReturn2["default"])(this, (0, _getPrototypeOf2["default"])(Swap).apply(this, arguments));
  }

  (0, _createClass2["default"])(Swap, [{
    key: "render",
    value: function render() {
      // eslint-disable-next-line no-shadow
      var onSwap = this.props.onSwap;
      return _react["default"].createElement(_styled.SwapContainer, {
        onClick: onSwap
      }, _react["default"].createElement(_styled.SwapIcon, {
        name: "left-right",
        size: "xxsmall",
        inheritColor: true
      }));
    }
  }]);
  return Swap;
}(_react.PureComponent);

(0, _defineProperty2["default"])(Swap, "defaultProps", {
  onSwap: null
});
(0, _defineProperty2["default"])(Swap, "propTypes", {
  onSwap: _propTypes["default"].func
});

// eslint-disable-next-line no-shadow
var ControlsGroup = function ControlsGroup(_ref) {
  var children = _ref.children,
      onSwap = _ref.onSwap,
      props = (0, _objectWithoutProperties2["default"])(_ref, ["children", "onSwap"]);

  if (!children.length || children.length === 1) {
    return children;
  }

  var controls = children;

  if (children.length === 2 && onSwap) {
    controls = [children[0], _react["default"].createElement(Swap, {
      onSwap: onSwap
    }), children[1]];
  }

  return _react["default"].createElement(_styled.FlexContainer, props, _react["default"].Children.toArray(controls.map(function (child, index, _ref2) {
    var length = _ref2.length;
    return _react["default"].cloneElement(child, {
      neighboringInGroup: getNeighboringInGroup(index, length)
    });
  })));
};

ControlsGroup.propTypes = {
  onSwap: _propTypes["default"].func,
  children: _propTypes["default"].node.isRequired
};
ControlsGroup.defaultProps = {
  onSwap: null
};
var _default = ControlsGroup;
exports["default"] = _default;